import { MapPin, Bus, Car, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import SectionHead from "./SectionHead";

export default function Standort() {
  return (
    <section id="standort" data-testid="standort-section" className="px-6 py-24 md:px-10 md:py-36">
      <div className="mx-auto grid max-w-6xl items-center gap-14 lg:grid-cols-2">
        <div>
          <SectionHead chapter="05" eyebrow="Standort" title="Mitten in Hemelingen." />
          <Reveal delay={0.15}>
            <div className="mt-10 flex items-start gap-4">
              <MapPin size={20} className="mt-1 shrink-0 text-[#c9a24a]" />
              <p className="leading-relaxed text-[#c9bda9]" data-testid="address-block">
                <span className="text-[#f4ecdd]">Vintage Billard</span>
                <br />
                Hemelinger Heerstraße 7<br />
                28309 Bremen
              </p>
            </div>
            <div className="mt-6 flex items-start gap-4">
              <Bus size={20} className="mt-1 shrink-0 text-[#c9a24a]" />
              <p className="leading-relaxed text-[#c9bda9]" data-testid="bus-info">
                Buslinien 40 & 41 — nur wenige Gehminuten entfernt.
              </p>
            </div>
            <div className="mt-6 flex items-start gap-4">
              <Car size={20} className="mt-1 shrink-0 text-[#c9a24a]" />
              <p className="leading-relaxed text-[#c9bda9]" data-testid="parking-info">
                Parkplätze sind vorhanden — kommt entspannt mit dem Auto.
              </p>
            </div>
            <a
              data-testid="route-button"
              href="https://www.google.com/maps/dir/?api=1&destination=Vintage+Billard,+Hemelinger+Heerstra%C3%9Fe+7,+28309+Bremen"
              target="_blank"
              rel="noreferrer"
              className="mt-10 inline-flex items-center gap-2 border border-[#c9a24a] px-8 py-4 text-sm uppercase tracking-[0.18em] text-[#c9a24a] transition-colors duration-300 hover:bg-[#c9a24a] hover:text-[#120d0b]"
            >
              Route planen <ArrowUpRight size={16} />
            </a>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <div className="border border-[#241a15]">
            <iframe
              data-testid="maps-embed"
              title="Karte: Vintage Billard, Bremen"
              src="https://www.google.com/maps?q=Vintage%20Billard%2C%20Hemelinger%20Heerstra%C3%9Fe%207%2C%2028309%20Bremen&output=embed"
              className="h-[420px] w-full brightness-[0.9] contrast-[1.05] grayscale-[30%] sepia-[20%]"
              loading="lazy"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
